import { House, Infinity, CircleX, Handshake, CheckCheck, Expand, BadgeDollarSign, BrainCircuit, ThumbsUp, Shield } from "lucide-react";

import { Button } from "../../components/ui/button";
import { FREE_PERMITTED_LIMIT, FREE_PERMITTED_LIMIT_TIME_FRAME_DAY } from '../../components/common/constants/constants';

import SectionHeading from "../../components/common/SectionHeading";

import quickbooksImg from "../../components/image/assets/quickbooks-logo.svg";
import { FORMATTED_MONTHLY_FEE, MONTHLY_FEE } from '../../components/common/constants/constants';

export default function WhyChooseSection() {
  return (
    <section className="section-padding">
      <div className="container-safe">
        <SectionHeading
          title="Why Pros Choose MrJoe.Pro"
          description="We get the grind: tackling real challenges in home improvement and construction."
        />

        {/* Three pillars */}
        <div className="xs:mt-10 mt-6 flex flex-wrap justify-around gap-10 text-center md:mt-14">
          <FeaturePillar icon={House} title="Tailored Exclusively for Pros" />
          <FeaturePillar icon={Handshake} title="Full Toolkit for Daily Wins" />
          <FeaturePillar icon={CheckCheck} title="Intuitive from Day One" />
        </div>


<div className="xs:mt-10 mt-6 flex flex-col md:flex-row justify-center items-center md:items-stretch gap-6 md:gap-8 md:mt-14">
  <article className="bg-page-gray-soft shadow-card-pricing hover:shadow-card-hover w-full max-w-[385px] rounded-2xl p-8 text-center sm:p-12 flex flex-col">
    <h3 className="text-2xl leading-8 font-semibold">Free Plan</h3>
    <p className="mt-3 leading-6">Up to {FREE_PERMITTED_LIMIT} Creations/{FREE_PERMITTED_LIMIT_TIME_FRAME_DAY} Days</p>
    <div className="text-primary mt-7 text-4xl tracking-tight">FREE</div>
    <ul className="mt-7 space-y-4 text-left flex-grow">
      <li className="flex items-center gap-3">
        <Expand className="size-5 shrink-0" />
        <span className="leading-6">Access All Features</span>
      </li>
      <li className="flex items-center gap-3">
        <Shield className="size-6 shrink-0" />
        <span className="leading-6">{FREE_PERMITTED_LIMIT} Projects/Estimates/Invoices Every {FREE_PERMITTED_LIMIT_TIME_FRAME_DAY} Days</span>
      </li>
      <li className="flex items-center gap-3">
        <Infinity className="size-5 shrink-0" />
        <span className="leading-6">Unlimited Everything Else</span>
      </li>
    </ul>
    <Button className="mt-7 w-full">
      <a href="../create_company">
        Start Free
      </a>
    </Button>
    <p className="text-paragraph xs:mt-4 mt-3 text-xs leading-5">
      No card needed. Unlock full toolkit—scale worry-free.
    </p>
  </article>
  
  <article className="bg-page-gray-soft shadow-card-pricing hover:shadow-card-hover w-full max-w-[385px] rounded-2xl p-8 text-center sm:p-12 flex flex-col">
    <h3 className="text-2xl leading-8 font-semibold">Unlimited Plan</h3>
    <p className="mt-3 leading-6">{FORMATTED_MONTHLY_FEE}/month</p>
    <div className="text-primary mt-7 text-4xl tracking-tight">Unlimited Access</div>
    <ul className="mt-7 space-y-4 text-left flex-grow">
      <li className="flex items-center gap-3">
        <ThumbsUp className="size-5 shrink-0" />
        <span className="leading-6">All Features, No Limits</span>
      </li>
      <li className="flex items-center gap-3">
        <BadgeDollarSign className="shrink-0" />
        <span className="leading-6">Flexible Billing: 1 Month or More</span>
      </li>
      <li className="flex items-center gap-3">
        <CircleX className="size-5 shrink-0" />
        <span className="leading-6">Cancel Anytime, Risk-Free</span>
      </li>
    </ul>
    <Button className="mt-7 w-full">
      <a href="../create_company">
        Go Unlimited
      </a>
    </Button>
    <p className="text-paragraph xs:mt-4 mt-3 text-xs leading-5">
      Zero hidden fees. Power up and grow without bounds.
    </p>
  </article>
</div>


      </div>

    </section>
  );
}

function FeaturePillar({
  icon: Icon,
  title
}: {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  title: string;
}) {
  return (
    <div className="flex flex-col items-center gap-2 sm:gap-4">
      <Icon className="xs:size-8 size-6" />
      <p className="xs:leading-6 max-xs:text-xs max-w-[145px] leading-4 sm:max-w-[200px]">
        {title}
      </p>
    </div>
  );
}
